//Окно добавления комментария
import AddNotification from '@/components/ui/notifications/add-notification/AddNotification'

export default {
    methods: {
         openNotificationModal(url, id) {
            this.$store.dispatch('modalOpen', {
                component: AddNotification,
                data: {
                    url: url,
                    id: id
                }
            })
        }
    }
}